export const ddIgnorableErrors = [
  'ORCA-IGNORE',
  'ResizeObserver loop completed with undelivered notifications',
  'Object Not Found Matching Id',
  'Abort fetching component for route',
  'Route did not complete loading',
  'Uncaught "Object Not Found Matching Id"',
];
